<script>
	import { generateMetaTags, generateHreflangLinks, generateStructuredData, seoConfig } from '$lib/seo.js';
	import { page } from '$app/stores';
	
	export let title = '';
	export let description = '';
	export let keywords = '';
	export let image = '';
	export let type = 'website';
	export let structuredData = null;
	export let pageName = 'home';
	
	// costruisce tags aggiungendo solo le voci non nulle o vuote
	$: tags = {
		title: title || null,
		description: description || null,
		keywords: keywords || null,
		image: image || null,
		type: type || 'website'
	};

	$: lang = $page.params.lang || 'en';
	$: metaTags = generateMetaTags(pageName, lang, Object.fromEntries(Object.entries(tags).filter(([, value]) => value !== null && value !== '')));
	$: hreflangLinks = generateHreflangLinks(pageName === 'home' ? '' : pageName);
	$: canonicalUrl = metaTags.url;
</script>

<svelte:head>
	<!-- Basic Meta Tags -->
	<title>{metaTags.title}</title>
	<meta name="description" content={metaTags.description} />
	<meta name="keywords" content={metaTags.keywords} />
	<meta name="author" content="Auting" />
	<meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
	<meta name="language" content={lang} />
	
	<!-- Canonical URL -->
	<link rel="canonical" href={canonicalUrl} />
	
	<!-- Hreflang for multilingual SEO -->
	{#each hreflangLinks as link}
		<link rel={link.rel} hreflang={link.hreflang} href={link.href} />
	{/each}
	
	<!-- Open Graph / Facebook -->
	<meta property="og:type" content={metaTags.type} />
	<meta property="og:url" content={metaTags.url} />
	<meta property="og:title" content={metaTags.title} />
	<meta property="og:description" content={metaTags.description} />
	<meta property="og:image" content={metaTags.image} />
	<meta property="og:image:width" content="1200" />
	<meta property="og:image:height" content="630" />
	<meta property="og:site_name" content="Auting" />
	<meta property="og:locale" content="{lang === 'en' ? 'en_US' : lang === 'it' ? 'it_IT' : 'fr_FR'}" />
	
	<!-- Twitter Card -->
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:url" content={metaTags.url} />
	<meta name="twitter:title" content={metaTags.title} />
	<meta name="twitter:description" content={metaTags.description} />
	<meta name="twitter:image" content={metaTags.image} />
	<meta name="twitter:site" content={seoConfig.twitterHandle} />
	<meta name="twitter:creator" content={seoConfig.twitterHandle} />
	
	<!-- Additional SEO Meta Tags -->
	<meta name="theme-color" content="#1a1a1a" />
	<meta name="msapplication-TileColor" content="#1a1a1a" />
	<meta name="application-name" content="Auting" />
	<meta name="apple-mobile-web-app-title" content="Auting" />
	<meta name="apple-mobile-web-app-capable" content="yes" />
	<meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
	
	<!-- Preconnect to external domains for performance -->
	<link rel="preconnect" href="https://fonts.googleapis.com" />
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
	
	<!-- DNS Prefetch for performance -->
	<link rel="dns-prefetch" href="https://www.google-analytics.com" />
	
	<!-- Structured Data for LLMs and Search Engines -->
	{#if structuredData}
		{@html `<script type="application/ld+json">${JSON.stringify(structuredData)}</script>`}
	{/if}
</svelte:head>